import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {ParkingPassComponent} from './parking-pass.component';
import {ParkingPassListComponent} from './parking-pass-list/parking-pass-list.component';
import {ParkingPassModalComponent} from './parking-pass-modal/parking-pass-modal.component';
import {ParkingPassService} from '../../services/parking-pass.service';
import {ParkingPassPaymentComponent} from 'app/views/parking-pass/parking-pass-payment/parking-pass-payment.component';
import {ParkingPassesFilterComponent} from '../../components/parking-passes-filter/parking-passes-filter.component';
import {ParkingPassViewComponent} from './parking-pass-view/parking-pass-view.component';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {FilterByPropertyPipeModule} from '../../pipes/filter-by-property-pipe/filter-by-property-pipe.module';
import {ParkingPassDetailedViewComponent} from './parking-pass-detailed-view/parking-pass-detailed-view.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        SafeHtmlPipeModule,
        ScrollDispatchModule,
        FilterByPropertyPipeModule,
        UtilsModule
    ],
    declarations: [
        ParkingPassComponent,
        ParkingPassListComponent,
        ParkingPassModalComponent,
        ParkingPassPaymentComponent,
        ParkingPassesFilterComponent,
        ParkingPassViewComponent,
        ParkingPassDetailedViewComponent
    ],
    providers: [
        ParkingPassService
    ],
    exports: [
        ParkingPassModalComponent
    ]
})
export class ParkingPassModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass.module.ts